export default function TV() {
    return (
        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_925_43134)">
                <path
                    d="M34.875 8.32861H6.125C5.08947 8.32861 4.25 9.16808 4.25 10.2036V27.7036C4.25 28.7391 5.08947 29.5786 6.125 29.5786H34.875C35.9105 29.5786 36.75 28.7391 36.75 27.7036V10.2036C36.75 9.16808 35.9105 8.32861 34.875 8.32861Z"
                    stroke="black"
                    strokeWidth="1.875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M32.375 12.0786H8.625C8.27982 12.0786 8 12.3584 8 12.7036V25.2036C8 25.5488 8.27982 25.8286 8.625 25.8286H32.375C32.7202 25.8286 33 25.5488 33 25.2036V12.7036C33 12.3584 32.7202 12.0786 32.375 12.0786Z"
                    stroke="black"
                    strokeWidth="1.875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9.25 33.0771L11.125 29.8296" stroke="black" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M32.375 33.0771L30.5 29.8296" stroke="black" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_925_43134">
                    <rect width="40" height="40" fill="white" transform="translate(0.5 0.828613)" />
                </clipPath>
            </defs>
        </svg>
    );
}
